import { EventsSection } from 'store/Components';
import { Stack } from 'ui';

import { useCausePageContext } from './CauseContext';

const Events = () => {
  const { cause } = useCausePageContext();
  return (
    <Stack>
      <EventsSection
        title=""
        causeId={cause?.uuid}
        eventCardProps={{ isColumn: false }}
        isStacked
        containerProps={{ mt: 'sm' }}
        eventLimit="none"
        navigateToEvent={(navigate, eventId) => {
          navigate(eventId);
        }}
      />
    </Stack>
  );
};

export { Events };
